import { BRAND_COLORS } from '../../../../constants/styles';
import { DateRangeType } from '../../../../types/phlebotomist-dashboard';
import { STATUS_COLORS } from '../../constants';

export interface IBarConfig {
  name: 'week' | 'month' | 'quarter' | 'year';
  period: DateRangeType;
  scale: number;
  color: string;
}

export const ROLLING_BARS: IBarConfig[] = [
  {
    name: 'week',
    period: 'week',
    scale: 365 / 7,
    color: '#2f3a45',
  },
  {
    name: 'month',
    period: 'month',
    scale: 365 / 30,
    color: BRAND_COLORS.secondary.steelBlue,
  },
  {
    name: 'quarter',
    period: 'quarter',
    scale: 365 / 90,
    color: BRAND_COLORS.primary.deepNavy,
  },
  {
    name: 'year',
    period: 'year',
    scale: 1,
    color: BRAND_COLORS.primary.royalBlue,
  },
];

export const CALENDAR_BARS: IBarConfig[] = [
  {
    name: 'week',
    period: 'weekCal',
    scale: 365 / 7,
    color: '#135200',
  },
  {
    name: 'month',
    period: 'monthCal',
    scale: 365 / 30,
    color: '#237804',
  },
  {
    name: 'quarter',
    period: 'quarterCal',
    scale: 365 / 90,
    color: STATUS_COLORS.good.border,
  },
  {
    name: 'year',
    period: 'yearCal',
    scale: 1,
    color: STATUS_COLORS.good.fill,
  },
];
